import React from "react";
import { Route, Switch } from "react-router-dom";
import BaseData from "./baseData/index";
import WebsiteData from "./website/index";

const App = ({ match }) => (
  <div className="gx-main-content-wrapper">
    <Switch>
    <Route path={`${match.url}baseData`} component={BaseData}/>
    <Route path={`${match.url}website`} component={WebsiteData} />
    </Switch>
  </div>
);

export default App;
